import React, { useState } from 'react'

// Centralized lodash imports - much cleaner!
import {
  map,
  find,
  ceil,
  slice,
  get,
  isString,
  every,
  isNil,
} from '@/utils/lodash'
import { useQuery } from "@apollo/client/react";
import { GET_AFFILIATE } from '@/housefolios-components/CreateAccount/CreateAccountCard/queries'
import {
  resolveUrlAffiliate,
  resolveUrlHelmetData,
} from '@/utils/affiliateHosts'

function useAffiliate({ memberValue = ''  }) {
  let memberURL

  const hostname = import.meta.env.VITE_HOSTNAME

  if (
    hostname === 'localhost' ||
    hostname === 'dev-admin.housefolios.com'
  ) {
    const urlParams = new URLSearchParams(window.location.search)
    memberURL = urlParams.get('domain')
  } else {
    memberURL = window.location.hostname
  }

  const urlAffiliate = resolveUrlAffiliate(memberURL)
  const requestedMemberValue = memberValue || urlAffiliate || ''
  const urlHelmetData = resolveUrlHelmetData(memberURL)

  let result = useQuery(GET_AFFILIATE, {
    variables: {
      memberValue: requestedMemberValue,
    },
    skip: requestedMemberValue === '',
    fetchPolicy: 'cache-first',
  })
  const affiliateLoading = result.loading
  const affiliate = result?.data?.affiliate || {}

  return [
    {
      affiliate,
      affiliateLoading,
      urlDomain: memberURL,
      urlAffiliate,
      urlHelmetData,
    },
  ]
}

export default useAffiliate
